function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.997,
    viewBox: "0 0 16 15.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 1",
    d: "M15607.9 3917h-7.563a3.334 3.334 0 0 1-3.332-3.332v-9.333a3.336 3.336 0 0 1 3.332-3.332h6.029a.666.666 0 0 1 0 1.333h-6.029a2 2 0 0 0-2 2v9.333a2 2 0 0 0 2 2h6.663V3913a2 2 0 0 1 2-2h2.669v-3.348a.667.667 0 0 1 1.333 0v4.242a3.307 3.307 0 0 1-.978 2.357l-1.77 1.772a3.313 3.313 0 0 1-2.348.975zm.437-4v2.614a1.962 1.962 0 0 0 .978-.533l1.774-1.772a2.031 2.031 0 0 0 .533-.975H15609a.666.666 0 0 0-.668.666zm-6.437.667h-.9a.668.668 0 0 1-.669-.667v-.9a3.305 3.305 0 0 1 .978-2.355l8.128-8.128a2.131 2.131 0 0 1 2.943 0 2.087 2.087 0 0 1 0 2.943l-8.128 8.128a3.31 3.31 0 0 1-2.348.975zm8.483-11.1-8.126 8.125a2.013 2.013 0 0 0-.585 1.414v.23h.228a2.02 2.02 0 0 0 1.414-.585l8.128-8.128a.749.749 0 0 0 0-1.056.763.763 0 0 0-1.059 0z",
    transform: "translate(-15597 -3901.002)",
    style: {
      fill: "#4f5f71"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2eee66af87dca4062b88664e79436ebd.svg";
export { ForwardRef as ReactComponent };